var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPaymentMastercard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 28,
    viewBox: "0 0 44 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 4.2C0.5 2.14801 2.13142 0.5 4.125 0.5H39.875C41.8686 0.5 43.5 2.14801 43.5 4.2V23.8C43.5 25.852 41.8686 27.5 39.875 27.5H4.125C2.13142 27.5 0.5 25.852 0.5 23.8V4.2Z",
    fill: "white",
    stroke: "#F2EFEE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1134 5.74487H16.887V22.255H27.1134V5.74487Z",
    fill: "#F16122"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9426 14C17.9426 10.6506 19.5292 7.66759 22.0001 5.74495C20.193 4.33897 17.913 3.5 15.435 3.5C9.5684 3.5 4.8125 8.20111 4.8125 14C4.8125 19.7989 9.5684 24.5 15.435 24.5C17.913 24.5 20.193 23.6612 22.0001 22.2551C19.5292 20.3326 17.9426 17.3496 17.9426 14Z",
    fill: "#E91D25"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M39.1876 14C39.1876 19.7989 34.4317 24.5 28.5651 24.5C26.0871 24.5 23.807 23.6612 22 22.2551C24.4709 20.3324 26.0573 17.3494 26.0573 14C26.0573 10.6506 24.4707 7.66759 22 5.74495C23.807 4.33897 26.0869 3.5 28.5651 3.5C34.4319 3.5 39.1876 8.20111 39.1876 14Z",
    fill: "#F79E1D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentMastercard);
export default __webpack_public_path__ + "static/media/payment-mastercard.4f0c8193033c743f5adcb6c2ba5e030e.svg";
export { ForwardRef as ReactComponent };